import { app } from '../../../../../../app';
import { appProtocolDisplayName } from '../../../../../../../util/sp-util';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.applications.assign', {
        url: '/assign',
        views: {
            '@company.idp-authenticators.manage': 'companyIdpAuthenticatorsManageApplicationsAssign'
        },
        resolve: {
            applications,
        },
    });
}

/** @ngInject */
function applications(companyId, idpAuthenticator, IdpAuthenticatorsService) {
    return IdpAuthenticatorsService.getAssignableApplications(companyId, idpAuthenticator.id)
    .then(applications => applications.map(app => ({...app, protocol: appProtocolDisplayName(app)})));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/applications/assign/idp-authenticator-applications-assign.state.js